<div
  class="add-to-gallery-text"
  [innerHTML]="text"></div>
<div class="add-to-gallery-img"></div>
